import React from "react";
import translate from "../../reusable/translate";
import Tooltip from "../../materialCommitment/tooltip/Tooltip";

import { bindActionCreators } from "redux";
import { useDispatch, useSelector } from "react-redux";

import validatorSlice from "../../../state/slices/validatorSlice";

const ValueTypeMeter = ({
  meter,
  changeStartingLevel,
  changeTargetLevel,
  disabled
}) => {
  const { language } = useSelector(state => state);

  return (
    <div>
      <div className="flex-row items-center margin-top-bot">
        <div className="w300">
          <div className="flex-row">
            <p className="p">
              {translate({
                textKey: "sit.commitmentCreation.setLevelsOnlyNumbers",
                languageOverride: language
              })}
            </p>
            <Tooltip
              textKey={"tooltip.setLevels.871646"}
              languageOverride={language}
            />
          </div>
        </div>

        <LevelsContainer
          startingLevel={meter.startingLevel || ""}
          setStartingLevel={changeStartingLevel}
          targetLevel={meter.targetLevel || ""}
          setTargetLevel={changeTargetLevel}
          disabled={disabled}
        />
      </div>
    </div>
  );
};

export default ValueTypeMeter;

const LevelsContainer = ({
  startingLevel,
  setStartingLevel,
  targetLevel,
  setTargetLevel,
  disabled
}) => {
  const { validators, language } = useSelector(state => state);
  const dispatch = useDispatch();
  const { changeLevelValidator } = bindActionCreators(
    validatorSlice.actions,
    dispatch
  );

  return (
    <div className="flex-row items-center w500 space-between">
      <input
        className={`input-number ${
          validators.level ? "" : "input-number-validated"
        }`}
        type="number"
        value={startingLevel}
        placeholder={translate({
          textKey: "sit.commitmentCreation.setStartingLevel.871646",
          languageOverride: language
        })}
        onChange={e => {
          changeLevelValidator(true);
          setStartingLevel(e.target.value);
        }}
        disabled={disabled}
      />
      <i className="fas fa-arrow-right" />
      <input
        className={`input-number ${
          validators.level ? "" : "input-number-validated"
        }`}
        type="number"
        value={targetLevel}
        placeholder={translate({
          textKey: "sit.commitmentCreation.setTargetLevel.871646",
          languageOverride: language
        })}
        onChange={e => {
          changeLevelValidator(true);
          setTargetLevel(e.target.value);
        }}
        disabled={disabled}
      />
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/components/circularEconomyCommitment/meter/ValueTypeMeter.jsx